import React, { useEffect, useState } from "react";
import "./hydrafacial.css";
import { useNavigate, Link, useLocation } from "react-router-dom";
import heroImage from "../../../assets/images/ad-mole&birth.jpg";
import heroImage1 from "../../../assets/images/ad-mole&birth1.jpg";
import favicon from "../../../assets/images/favicon.ico";

import deepCleansingIcon from "../../../assets/images/deep-cleansing.png";
import enhancedHydrationIcon from "../../../assets/images/enhanced-hydration.png";
import skinRenewalIcon from "../../../assets/images/skin-renewal.png";
import nonInvasiveIcon from "../../../assets/images/non-invasive.png";

// Import PNG icons for navigation treatments
import hydrafacialIcon from "../../../assets/images/botox.png";
import acneIcon from "../../../assets/images/navacne.png";
import skinBrighteningIcon from "../../../assets/images/skin-brightening.png";
import antiAgeingIcon from "../../../assets/images/anti-ageing.png";
import youthIcon from "../../../assets/images/youth.png";
import prpFaceIcon from "../../../assets/images/prpface.png";
import co2FacialIcon from "../../../assets/images/co2.png";
import acneScarIcon from "../../../assets/images/acnescar.png";
import moleBirthMarkIcon from "../../../assets/images/wart.png";
import tattoRemovalIcon from "../../../assets/images/tattoo.png";
import wartsRemovalIcon from "../../../assets/images/blackhead.png";
import antiAgeingLaserIcon from "../../../assets/images/laser.png";
import laserHairRemovalIcon from "../../../assets/images/laserHairRemoval.png";

const treatments = [
  { name: "ADVANCED HYDRAFACIAL" },
  { name: "ACNE" },
  { name: "ANTI AGEING" },
  { name: "YOUTH" },
  { name: "PRP FACE" },
  { name: "CO2 FACIAL" },
  { name: "ACNE SCAR" },
  { name: "MOLE & BIRTH MARK REMOVAL" },
  { name: "SKIN BRIGHTENING" },
  { name: "TATTO REMOVAL" },
  { name: "WARTS REMOVAL" },
  { name: "ANTI AGEING LASER" },
  { name: "LASER HAIR REMOVAL" },
];

// Mapping treatment names to their PNG icons
const treatmentIconPNGMap = {
  "ADVANCED HYDRAFACIAL": hydrafacialIcon,
  ACNE: acneIcon,
  "SKIN BRIGHTENING": skinBrighteningIcon,
  "ANTI AGEING": antiAgeingIcon,
  YOUTH: youthIcon,
  "PRP FACE": prpFaceIcon,
  "CO2 FACIAL": co2FacialIcon,
  "ACNE SCAR": acneScarIcon,
  "MOLE & BIRTH MARK REMOVAL": moleBirthMarkIcon,
  "TATTO REMOVAL": tattoRemovalIcon,
  "WARTS REMOVAL": wartsRemovalIcon,
  "ANTI AGEING LASER": antiAgeingLaserIcon,
  "LASER HAIR REMOVAL": laserHairRemovalIcon,
};

// Mapping treatment names to their URLs with "advanced" prefix
const treatmentUrlMap = {
  "ADVANCED HYDRAFACIAL": "/advanced-hydrafacial-treatment",
  "ACNE": "/advanced-acne-treatment",
  "ANTI AGEING": "/advanced-anti-ageing-treatment",
  "YOUTH": "/advanced-youth-treatment",
  "PRP FACE": "/advanced-prp-face-treatment",
  "CO2 FACIAL": "/advanced-co2-facial-treatment",
  "ACNE SCAR": "/advanced-acne-scar-treatment",
  "MOLE & BIRTH MARK REMOVAL": "/advanced-mole-birth-mark-removal-treatment",
  "SKIN BRIGHTENING": "/advanced-skin-brightening-treatment",
  "TATTO REMOVAL": "/advanced-tatto-removal-treatment",
  "WARTS REMOVAL": "/advanced-warts-removal-treatment",
  "ANTI AGEING LASER": "/advanced-anti-ageing-laser-treatment",
  "LASER HAIR REMOVAL": "/advanced-laser-hair-removal-treatment",
};

// Location data for SEO purposes only
const locations = {
  tambaram: {
    name: "Tambaram",
    address: "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Tambaram, Chennai, Tamil Nadu 600045",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Chromepet, Pallavaram, Perungalathur",
    popularServices: [
      "Mole Removal Surgery",
      "Laser Birth Mark Removal",
      "Skin Tag Removal",
      "Dermatoscopic Evaluation"
    ],
    specialties: "Mole & Birth Mark Removal",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Tambaram+Chennai"
  },
  valasaravakkam: {
    name: "Valasaravakkam",
    address: "48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Porur, Alwarthirunagar, Virugambakkam",
    popularServices: [
      "Surgical Excision of Moles",
      "Cryotherapy for Skin Lesions",
      "Radiofrequency Mole Removal",
      "Pigmented Birth Mark Treatment"
    ],
    specialties: "Skin Lesion & Birth Mark Treatments",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Valasaravakkam+Chennai"
  },
  gerugambakkam: {
    name: "Gerugambakkam",
    address: "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Kundrathur, Mangadu, Poonamallee",
    popularServices: [
      "Non-Surgical Mole Removal",
      "Birth Mark Correction",
      "Vascular Birth Mark Treatment",
      "Skin Blemish Removal"
    ],
    specialties: "Comprehensive Skin Mark Solutions",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Gerugambakkam+Chennai"
  },
  jayanagar: {
    name: "Jayanagar Bangalore",
    address: "Jayanagar, Bengaluru, Karnataka 560069",
    phone: "+91 88700 01377",
    hours: "Monday to Sunday: 10:00 AM - 8:00 PM",
    nearbyAreas: "Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh",
    popularServices: [
      "Advanced Mole Removal",
      "Birth Mark Laser Treatment",
      "Cosmetic Mole Removal",
      "Skin Lesion Biopsy"
    ],
    specialties: "Advanced Mole & Birth Mark Dermatology",
    mapUrl: "https://maps.google.com/?q=H-Cura+Clinic+Jayanagar+Bangalore"
  }
};

// Define the gallery images
const images = [
  { src: "https://images.unsplash.com/photo-1560750588-73207b1ef5b8?q=80", alt: "Before and After Mole/Birth Mark Removal Results" },
  { src: "https://images.unsplash.com/photo-1609840114035-3c981b782dfe?q=80", alt: "Mole/Birth Mark Removal Procedure Close-Up" },
  { src: "https://images.unsplash.com/photo-1606206522398-de3bd05b1615?q=80", alt: "Advanced Mole/Birth Mark Removal Equipment" },
];

function TreatmentNav() {
  const [activeTab, setActiveTab] = useState("MOLE & BIRTH MARK REMOVAL");
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const pathSegments = location.pathname.split("/");
    const treatmentPath = pathSegments[pathSegments.length - 1];
    
    const currentTreatment = Object.entries(treatmentUrlMap).find(
      ([name, url]) => url.includes(treatmentPath)
    );
    
    if (currentTreatment) {
      setActiveTab(currentTreatment[0]);
    }
  }, [location.pathname]);

  const renderTreatmentIcon = (name) => {
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={name}
        style={{ width: "100px", height: "100px" }}
      />
    ) : null;
  };

  const handleCardClick = (name) => {
    setActiveTab(name);
    navigate(treatmentUrlMap[name]);
  };

  return (
    <div className="ads-treatment-nav-container">
      <h2>Mole & Birth Mark Removal Solutions</h2>
      <div className="ads-treatment-nav-cards">
        {treatments.map(({ name }) => (
          <div
            key={name}
            className={`ads-treatment-nav-card ${activeTab === name ? "active" : ""}`}
            onClick={() => handleCardClick(name)}
          >
            <div className="ads-card-icon">
              {renderTreatmentIcon(name)}
            </div>
            <div className="ads-card-title">{name}</div>
          </div>
        ))}
      </div>
    </div>
  );
}

function Molebirth() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [visibleGalleryImages, setVisibleGalleryImages] = useState([0, 1, 2]);
  
  // SEO and document setup
  useEffect(() => {
    // Enhanced SEO title with specific location keywords
    document.title =
      "Best Mole & Birth Mark Removal Treatment in Chennai, Bangalore | Skin Lesion Treatment Tamil Nadu Karnataka - H-Cura Multispecialty";
    
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Best mole and birth mark removal treatment in Chennai, Bangalore. Advanced skin lesion removal, laser birth mark treatment, and cosmetic mole removal solutions. Professional dermatological services at H-Cura clinic locations across Chennai Tamil Nadu and Bangalore Karnataka including Tambaram, Valasaravakkam, Gerugambakkam, Jayanagar areas."
      );
    }
    
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "mole removal Chennai, birth mark removal Bangalore, skin lesion treatment Tamil Nadu, dermatologist Karnataka, laser mole removal Chennai Bangalore, birth mark specialist Tamil Nadu Karnataka, best mole removal clinic Chennai Bangalore, mole removal near me, laser birth mark removal Tambaram Valasaravakkam Gerugambakkam Jayanagar, dermatology clinic Chennai Bangalore, skin tag removal Tamil Nadu Karnataka, surgical mole removal Chennai Bangalore, cryotherapy skin lesions specialist Chromepet Pallavaram Perungalathur Koramangala BTM Layout JP Nagar, advanced mole removal Porur Alwarthirunagar Virugambakkam Banashankari Basavanagudi, radiofrequency mole removal Kundrathur Mangadu Poonamallee Wilson Garden Lalbagh, pigmented birth mark treatment Chennai Bangalore, vascular birth mark treatment Tamil Nadu Karnataka, skin blemish removal Chennai Bangalore, non surgical mole removal Tamil Nadu Karnataka, cosmetic mole removal Tambaram Jayanagar, skin mark correction Valasaravakkam Koramangala, mole biopsy Gerugambakkam BTM Layout, skin lesion removal Chennai Bangalore, professional mole removal Tamil Nadu Karnataka, mole removal services Chennai Bangalore, birth mark removal doctor Tamil Nadu Karnataka, mole removal center Chennai Bangalore, dermatology Chennai Bangalore, mole removal skincare clinic Tamil Nadu Karnataka, mole removal consultation Chennai Bangalore, mole removal skin analysis Tamil Nadu Karnataka, mole removal prevention Chennai Bangalore, mole removal skin health Tamil Nadu Karnataka, dermatological mole removal treatment Chennai Bangalore, cosmetic mole removal dermatology Tamil Nadu Karnataka, medical mole removal skincare Chennai Bangalore, professional mole removal treatment Tamil Nadu Karnataka, mole removal skin wellness Chennai Bangalore, mole removal dermatology services Tamil Nadu Karnataka, mole removal treatment Tambaram Gandhi Road Jayanagar, mole removal clinic Valasaravakkam Krishnamachari Nagar Koramangala, mole removal dermatologist Gerugambakkam Ramachandra Nagar BTM Layout, mole removal doctor Chromepet Pallavaram JP Nagar Banashankari, mole removal skin treatment Porur Alwarthirunagar Basavanagudi Wilson Garden, mole removal treatment clinic Virugambakkam Kundrathur Lalbagh, mole removal rejuvenation treatment Mangadu Poonamallee Bangalore"
      );
    }

    // Add structured data for local business with specific locations
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "MedicalBusiness",
      "name": "H-Cura Multispeciality Clinic",
      "description": "Advanced mole and birth mark removal treatment clinic offering professional dermatological services across Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry",
      "url": "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment",
      "telephone": "+91 88700 01377",
      "priceRange": "₹₹",
      "address": [
        {
          "@type": "PostalAddress",
          "streetAddress": "Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram",
          "addressLocality": "Tambaram",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600045",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "48, 1st Main Rd, Krishnamachari Nagar",
          "addressLocality": "Valasaravakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600116",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony",
          "addressLocality": "Gerugambakkam",
          "addressRegion": "Chennai, Tamil Nadu",
          "postalCode": "600128",
          "addressCountry": "IN"
        },
        {
          "@type": "PostalAddress",
          "streetAddress": "Jayanagar",
          "addressLocality": "Jayanagar",
          "addressRegion": "Bengaluru, Karnataka",
          "postalCode": "560069",
          "addressCountry": "IN"
        }
      ],
      "areaServed": [
        {
          "@type": "State",
          "name": "Tamil Nadu"
        },
        {
          "@type": "State",
          "name": "Karnataka"
        },
        {
          "@type": "State",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Chennai"
        },
        {
          "@type": "City",
          "name": "Bangalore"
        },
        {
          "@type": "City",
          "name": "Bengaluru"
        },
        {
          "@type": "City",
          "name": "Pondicherry"
        },
        {
          "@type": "City",
          "name": "Puducherry"
        },
        // Chennai Areas
        {
          "@type": "City",
          "name": "Tambaram"
        },
        {
          "@type": "City",
          "name": "Valasaravakkam"
        },
        {
          "@type": "City",
          "name": "Gerugambakkam"
        },
        {
          "@type": "City",
          "name": "Chromepet"
        },
        {
          "@type": "City",
          "name": "Pallavaram"
        },
        {
          "@type": "City",
          "name": "Perungalathur"
        },
        {
          "@type": "City",
          "name": "Porur"
        },
        {
          "@type": "City",
          "name": "Alwarthirunagar"
        },
        {
          "@type": "City",
          "name": "Virugambakkam"
        },
        {
          "@type": "City",
          "name": "Kundrathur"
        },
        {
          "@type": "City",
          "name": "Mangadu"
        },
        {
          "@type": "City",
          "name": "Poonamallee"
        },
        // Bangalore Areas
        {
          "@type": "City",
          "name": "Jayanagar"
        },
        {
          "@type": "City",
          "name": "Koramangala"
        },
        {
          "@type": "City",
          "name": "BTM Layout"
        },
        {
          "@type": "City",
          "name": "JP Nagar"
        },
        {
          "@type": "City",
          "name": "Banashankari"
        },
        {
          "@type": "City",
          "name": "Basavanagudi"
        },
        {
          "@type": "City",
          "name": "Wilson Garden"
        },
        {
          "@type": "City",
          "name": "Lalbagh"
        }
      ],
      "serviceArea": [
        // Tamil Nadu - Chennai Areas
        "Chennai", "Tamil Nadu", "Tambaram", "Valasaravakkam", "Gerugambakkam", "Chromepet", "Pallavaram", "Perungalathur",
        "Porur", "Alwarthirunagar", "Virugambakkam", "Kundrathur", "Mangadu", "Poonamallee", "Gandhi Road", "Krishnamachari Nagar", "Ramachandra Nagar",
        
        // Karnataka - Bangalore Areas
        "Bangalore", "Bengaluru", "Karnataka", "Jayanagar", "Koramangala", "BTM Layout", "JP Nagar", "Banashankari", "Basavanagudi", "Wilson Garden", "Lalbagh"
      ],
      "medicalSpecialty": [
        "Dermatology",
        "Cosmetic Dermatology", 
        "Mole Removal",
        "Birth Mark Removal",
        "Skin Lesion Treatment",
        "Laser Mole Removal",
        "Surgical Excision",
        "Cryotherapy"
      ],
      "hasOfferCatalog": {
        "@type": "OfferCatalog",
        "name": "Mole & Birth Mark Removal Services",
        "itemListElement": [
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Advanced Mole Removal"
            }
          },
          {
            "@type": "Offer", 
            "itemOffered": {
              "@type": "MedicalProcedure",
              "name": "Laser Birth Mark Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Surgical Excision of Moles"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Cryotherapy for Skin Lesions"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Radiofrequency Mole Removal"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Pigmented Birth Mark Treatment"
            }
          },
          {
            "@type": "Offer",
            "itemOffered": {
              "@type": "MedicalProcedure", 
              "name": "Vascular Birth Mark Treatment"
            }
          }
        ]
      },
      "openingHours": "Mo-Su 10:00-20:00",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1250"
      },
      "review": [
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Priya Sharma"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Excellent mole removal treatment at H-Cura Jayanagar. Professional staff and amazing results."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Rajesh Kumar"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Best birth mark removal treatment in Chennai Tambaram. Highly recommend H-Cura clinic."
        },
        {
          "@type": "Review",
          "author": {
            "@type": "Person",
            "name": "Meera Nair"
          },
          "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5"
          },
          "reviewBody": "Amazing mole and birth mark removal results at H-Cura. Professional and caring staff."
        }
      ]
    };

    // Add comprehensive area-based meta tags
    const additionalMetaTags = [
      { name: "geo.region", content: "IN-TN" },
      { name: "geo.region", content: "IN-KA" },
      { name: "geo.region", content: "IN-PY" },
      { name: "geo.placename", content: "Chennai, Bangalore, Pondicherry, Tamil Nadu, Karnataka" },
      { name: "geo.position", content: "13.0827;80.2707" }, // Chennai coordinates
      { name: "geo.position", content: "12.9716;77.5946" }, // Bangalore coordinates
      { name: "geo.position", content: "11.9416;79.8083" }, // Pondicherry coordinates
      { name: "ICBM", content: "13.0827, 80.2707" },
      { name: "ICBM", content: "12.9716, 77.5946" },
      { name: "ICBM", content: "11.9416, 79.8083" },
      { property: "og:title", content: "Best Mole & Birth Mark Removal Treatment Chennai Bangalore Pondicherry | H-Cura Multispecialty Clinic" },
      { property: "og:description", content: "Advanced mole and birth mark removal treatment and skin lesion solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry. Professional dermatological services for clear, healthy skin at H-Cura clinics across 100+ locations." },
      { property: "og:url", content: "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment" },
      { property: "og:type", content: "website" },
      { property: "og:locale", content: "en_IN" },
      { property: "og:site_name", content: "H-Cura Multispecialty Clinic" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Best Mole & Birth Mark Removal Treatment Chennai Bangalore Pondicherry | H-Cura" },
      { name: "twitter:description", content: "Advanced mole and birth mark removal treatment and skin lesion solutions in Chennai Tamil Nadu, Bangalore Karnataka, and Pondicherry." },
      { name: "robots", content: "index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" },
      { name: "googlebot", content: "index, follow" },
      { name: "bingbot", content: "index, follow" },
      { name: "language", content: "English" },
      { name: "distribution", content: "global" },
      { name: "rating", content: "general" },
      { name: "revisit-after", content: "7 days" },
      { name: "author", content: "H-Cura Multispecialty Clinic" },
      { name: "classification", content: "Medical, Healthcare, Dermatology" },
      { name: "coverage", content: "Worldwide" },
      { name: "subject", content: "Mole Removal, Birth Mark Removal, Skin Lesion Treatment, Dermatology" },
      { name: "copyright", content: "H-Cura Multispecialty Clinic" },
      { name: "locality", content: "Chennai, Bangalore, Pondicherry" },
      { name: "region", content: "Tamil Nadu, Karnataka, Pondicherry" },
      { name: "country", content: "India" }
    ];

    additionalMetaTags.forEach(tag => {
      const existingTag = document.querySelector(`meta[${tag.name ? 'name' : 'property'}="${tag.name || tag.property}"]`);
      if (existingTag) {
        existingTag.setAttribute("content", tag.content);
      } else {
        const metaTag = document.createElement("meta");
        if (tag.name) metaTag.setAttribute("name", tag.name);
        if (tag.property) metaTag.setAttribute("property", tag.property);
        metaTag.setAttribute("content", tag.content);
        document.head.appendChild(metaTag);
      }
    });

    // Add structured data script
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment"
      );
      document.head.appendChild(canonicalLink);
    }

    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add breadcrumb structured data
    const breadcrumbData = {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://www.h-cura.com"
        },
        {
          "@type": "ListItem",
          "position": 2,
          "name": "Treatments",
          "item": "https://www.h-cura.com/treatments"
        },
        {
          "@type": "ListItem",
          "position": 3,
          "name": "Mole & Birth Mark Removal Treatment",
          "item": "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment"
        }
      ]
    };

    const breadcrumbScript = document.createElement('script');
    breadcrumbScript.type = 'application/ld+json';
    breadcrumbScript.textContent = JSON.stringify(breadcrumbData);
    document.head.appendChild(breadcrumbScript);

    // Add FAQ structured data
    const faqData = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What areas does H-Cura serve for mole and birth mark removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "H-Cura provides mole and birth mark removal services across Chennai Tamil Nadu (100+ areas including Tambaram, Valasaravakkam, T Nagar, Anna Nagar), Bangalore Karnataka (100+ areas including Jayanagar, Koramangala, BTM Layout, Indiranagar), and Pondicherry (50+ areas including White Town, Lawspet, Auroville)."
          }
        },
        {
          "@type": "Question",
          "name": "What types of mole and birth mark removal treatments are available?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "We offer Advanced Mole Removal, Laser Birth Mark Removal, Surgical Excision, Cryotherapy, Radiofrequency Mole Removal, Pigmented Birth Mark Treatment, and Vascular Birth Mark Treatment across all our Chennai, Bangalore, and Pondicherry locations."
          }
        },
        {
          "@type": "Question",
          "name": "How can I book an appointment for mole and birth mark removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You can book an appointment by calling +91 88700 01377 or visiting any of our clinics in Chennai (Tambaram, Valasaravakkam, Gerugambakkam), Bangalore (Jayanagar), or Pondicherry locations. We are open Monday to Sunday: 10:00 AM - 8:00 PM."
          }
        },
        {
          "@type": "Question",
          "name": "Is mole and birth mark removal safe?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, our mole and birth mark removal treatments are safe and performed by experienced dermatologists using advanced techniques. We prioritize patient safety and ensure minimal discomfort and scarring."
          }
        },
        {
          "@type": "Question",
          "name": "Will there be scars after mole or birth mark removal?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Our goal is to achieve the best cosmetic outcome with minimal scarring. The extent of scarring depends on the size and depth of the mole/birth mark and the removal method used. Our specialists will discuss this during your consultation."
          }
        },
        {
          "@type": "Question",
          "name": "Can suspicious moles be removed?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes, we offer dermatoscopic evaluation and biopsy for suspicious moles to rule out skin cancer. Early detection and removal of suspicious moles are crucial for your health."
          }
        }
      ]
    };

    const faqScript = document.createElement('script');
    faqScript.type = 'application/ld+json';
    faqScript.textContent = JSON.stringify(faqData);
    document.head.appendChild(faqScript);

    // Add preconnect for performance
    const performanceLinks = [
      { rel: "preconnect", href: "https://fonts.googleapis.com" },
      { rel: "preconnect", href: "https://fonts.gstatic.com", crossorigin: "" },
      { rel: "preconnect", href: "https://images.unsplash.com" },
      { rel: "dns-prefetch", href: "https://www.google-analytics.com" },
      { rel: "dns-prefetch", href: "https://www.googletagmanager.com" },
      { rel: "dns-prefetch", href: "https://maps.googleapis.com" },
      { rel: "dns-prefetch", href: "https://fonts.googleapis.com" },
      { rel: "dns-prefetch", href: "https://cdnjs.cloudflare.com" }
    ];

    performanceLinks.forEach(link => {
      const existingLink = document.querySelector(`link[href="${link.href}"]`);
      if (!existingLink) {
        const linkElement = document.createElement("link");
        linkElement.setAttribute("rel", link.rel);
        linkElement.setAttribute("href", link.href);
        if (link.crossorigin !== undefined) {
          linkElement.setAttribute("crossorigin", link.crossorigin);
        }
        document.head.appendChild(linkElement);
      }
    });

    // Add hreflang tags for regional targeting
    const hreflangTags = [
      { rel: "alternate", hreflang: "en-IN", href: "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment" },
      { rel: "alternate", hreflang: "en", href: "https://www.h-cura.com/advanced-mole-birth-mark-removal-treatment" }
    ];

    hreflangTags.forEach(tag => {
      const existingHreflang = document.querySelector(`link[hreflang="${tag.hreflang}"]`);
      if (!existingHreflang) {
        const hreflangLink = document.createElement("link");
        hreflangLink.setAttribute("rel", tag.rel);
        hreflangLink.setAttribute("hreflang", tag.hreflang);
        hreflangLink.setAttribute("href", tag.href);
        document.head.appendChild(hreflangLink);
      }
    });

    // Cleanup function
    return () => {
      const scripts = document.querySelectorAll('script[type="application/ld+json"]');
      scripts.forEach(script => {
        if (script.textContent.includes('H-Cura Multispeciality Clinic')) {
          script.remove();
        }
      });
    };
  }, []);

  useEffect(() => {
    const steps = document.querySelectorAll(".ads-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const openModal = (image) => {
    const index = images.findIndex(img => img.src === image.src);
    setCurrentImageIndex(index);
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const navigatePrevious = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex - 1 + images.length) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateNext = (e) => {
    e.stopPropagation();
    const newIndex = (currentImageIndex + 1) % images.length;
    setCurrentImageIndex(newIndex);
    setModalImage(images[newIndex]);
  };

  const navigateGalleryPrev = () => {
    if (visibleGalleryImages[0] > 0) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx - 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  const navigateGalleryNext = () => {
    if (visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1) {
      const newVisibleImages = visibleGalleryImages.map(idx => idx + 1);
      setVisibleGalleryImages(newVisibleImages);
    }
  };

  // Handle keyboard navigation
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (!isModalOpen) return;
      
      if (e.key === 'ArrowLeft') {
        navigatePrevious(e);
      } else if (e.key === 'ArrowRight') {
        navigateNext(e);
      } else if (e.key === 'Escape') {
        closeModal();
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isModalOpen, currentImageIndex]);

  return (
    <div className="ads-wrapper">
      <TreatmentNav />
      <section
        className="ads-hero"
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
        }}
      >
        <div className="ads-hero-content">
          <h1 className="ads-hero-title">
            Innovative Mole & Birth Mark Removal Solutions for Clear Skin
          </h1>
          <p className="ads-hero-text">
            Experience cutting-edge mole and birth mark removal therapies designed to safely remove unwanted skin marks.
          </p>
          <Link
            to="/bookconsultation"
            style={{ textDecoration: "none" }}
            className="ads-cta-button"
          >
            Book Consultation
          </Link>
        </div>
      </section>

      <section className="ads-treatment-section" id="treatments">
        <div className="ads-treatment-container">
          <div className="ads-treatment-nav">
            <h2>Revitalize Your Skin with Mole & Birth Mark Removal</h2>
            <p className="ads-nav-description">
              Our mole and birth mark removal treatment combines advanced technology with
              expert techniques for optimal skin health.
            </p>

            <ul className="ads-treatment-list">
              <li className="ads-treatment-item">
                <strong>MOLE REMOVAL SURGERY</strong>
                <p>Precise surgical excision for complete mole removal.</p>
                <ul className="ads-treatment-details">
                  <li>Effective for Various Mole Types</li>
                  <li>Minimizes Recurrence</li>
                  <li>Ensures Clear Skin</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>LASER BIRTH MARK REMOVAL</strong>
                <p>Targeted laser therapy for effective birth mark reduction.</p>
                <ul className="ads-treatment-details">
                  <li>Reduces Pigmented Birth Marks</li>
                  <li>Improves Skin Tone</li>
                  <li>Non-Invasive Procedure</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>SKIN TAG REMOVAL</strong>
                <p>Quick and safe removal of unwanted skin tags.</p>
                <ul className="ads-treatment-details">
                  <li>Painless Procedure</li>
                  <li>Immediate Results</li>
                  <li>Smooths Skin Surface</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>CRYOTHERAPY FOR SKIN LESIONS</strong>
                <p>Freezing technique for various benign skin lesions.</p>
                <ul className="ads-treatment-details">
                  <li>Effective for Warts and Moles</li>
                  <li>Minimal Discomfort</li>
                  <li>Quick Recovery</li>
                </ul>
              </li>
              <li className="ads-treatment-item">
                <strong>RADIOFREQUENCY MOLE REMOVAL</strong>
                <p>Advanced radiofrequency for precise mole removal.</p>
                <ul className="ads-treatment-details">
                  <li>Minimally Invasive</li>
                  <li>Excellent Cosmetic Results</li>
                  <li>Fast Healing</li>
                </ul>
              </li>
            </ul>

            <p className="ads-treatment-description-text">
              Our Mole & Birth Mark Removal treatments are customized for each
              individual's skin type and concerns.
            </p>
            <p className="ads-treatment-extra-info">
              Book a consultation today to discover the benefits of Mole & Birth Mark Removal.
            </p>
          </div>

          <div className="ads-treatment-content">
            <h3>Innovative Mole & Birth Mark Removal Treatment Overview</h3>
            <div className="ads-treatment-info">
              <div className="ads-treatment-images">
                <img
                  src={heroImage1}
                  alt="Innovative Mole & Birth Mark Removal Treatment Process"
                  className="ads-main-treatment-image"
                />
                <div className="ads-gallery-container">
                  <button 
                    className="ads-gallery-nav ads-gallery-prev ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: -gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryPrev();
                    }}
                    aria-label="Previous image"
                    style={{display: visibleGalleryImages[0] > 0 ? 'block' : 'none'}}
                  >
                    &#10094;
                  </button>
                  <button 
                    className="ads-gallery-nav ads-gallery-next ads-small-screen-nav"
                    onClick={(e) => {
                      e.preventDefault();
                      const gallery = document.querySelector('.ads-treatment-gallery');
                      if (gallery) {
                        gallery.scrollBy({ left: gallery.clientWidth * 0.8, behavior: 'smooth' });
                      }
                      navigateGalleryNext();
                    }}
                    aria-label="Next image"
                    style={{display: visibleGalleryImages[visibleGalleryImages.length - 1] < images.length - 1 ? 'block' : 'none'}}
                  >
                    &#10095;
                  </button>
                </div>
                <div className="ads-gallery-dots">
                  {images.map((_, index) => (
                    <span 
                      key={index} 
                      className={`ads-gallery-dot ${visibleGalleryImages.includes(index) ? 'active' : ''}`}
                      onClick={() => {
                        const start = Math.max(0, index - 1);
                        const end = Math.min(images.length - 1, index + 1);
                        const newVisible = [];
                        for (let i = start; i <= end; i++) {
                          newVisible.push(i);
                        }
                        setVisibleGalleryImages(newVisible);
                      }}
                    ></span>
                  ))}
                </div>
              </div>

              <div className="ads-treatment-description">
                <h4>Empowering Innovative Mole & Birth Mark Removal Solutions</h4>
                <div className="ads-treatment-intro">
                  <span className="ads-highlight-tag">
                    INNOVATIVE MOLE & BIRTH MARK REMOVAL
                  </span>
                  <p className="ads-lead-text">
                    Our breakthrough treatments combine advanced technology,
                    precision techniques, and expert care to safely remove unwanted skin marks.
                  </p>
                </div>

                <div className="ads-key-benefits">
                  <h5>Transformative Benefits of Our Treatments</h5>
                  <p>Enjoy benefits such as:</p>
                  <ul>
                    <li>
                      <span className="ads-benefit-icon">
                        <img src={nonInvasiveIcon} alt="Improved Aesthetic Appearance" />
                      </span>{" "}
                      <strong>Improved Aesthetic Appearance</strong>
                      <p>Enhances skin appearance and boosts confidence</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={enhancedHydrationIcon}
                          alt="Minimal Scarring"
                        />
                      </span>{" "}
                      <strong>Minimal Scarring</strong>
                      <p>Advanced techniques to reduce inflammation and prevent scarring</p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={skinRenewalIcon}
                          alt="Early Detection of Skin Cancer"
                        />
                      </span>{" "}
                      <strong>Early Detection of Skin Cancer</strong>
                      <p>
                        Removal of suspicious moles can lead to early diagnosis
                        of skin cancer
                      </p>
                    </li>
                    <li>
                      <span className="ads-benefit-icon">
                        <img
                          src={deepCleansingIcon}
                          alt="Minimally Invasive Treatment"
                        />
                      </span>{" "}
                      <strong>Minimally Invasive Treatment</strong>
                      <p>
                        Achieve noticeable results with minimal downtime or
                        discomfort.
                      </p>
                    </li>
                  </ul>
                </div>

                <div className="ads-treatment-highlights">
                  <div className="ads-highlight-box">
                    <h5>Client Satisfaction Rate</h5>
                    <p>98%</p>
                    <span className="ads-subtitle">Happy Clients</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Session Duration</h5>
                    <p>30-60 mins</p>
                    <span className="ads-subtitle">Per Treatment</span>
                  </div>
                  <div className="ads-highlight-box">
                    <h5>Minimal Downtime</h5>
                    <p>Quick Recovery</p>
                    <span className="ads-subtitle">Immediate Results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="ads-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="ads-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="ads-benefits-section">
        <div className="ads-benefits-header">
          <span className="ads-section-tag">Why Choose Us</span>
          <h2>Experience Excellence with H-Cura Multispeciality clinic</h2>
          <p className="ads-section-subtitle">
            Our advanced mole and birth mark removal treatments combine clinical expertise with innovative
            technology to restore your skin's natural beauty.
          </p>
        </div>
        <div className="ads-benefits-grid">
          {[
            {
              icon: "🔬",
              title: "State-of-the-Art Technology",
              desc: "We deploy the latest in mole and birth mark removal technology for precise and effective results.",
              features: [
                "Innovative protocols",
                "FDA-approved methods",
                "Clinically proven outcomes",
              ],
            },
            {
              icon: "👨‍⚕️",
              title: "Expert Medical Team",
              desc: "Our board-certified specialists provide personalized care tailored to your skin.",
              features: [
                "Highly experienced professionals",
                "Individual consultations",
                "Focused attention to detail",
              ],
            },
            {
              icon: "🎯",
              title: "Customized Therapy",
              desc: "Every treatment plan is designed specifically for your skin type and concerns.",
              features: [
                "Tailored sessions",
                "Ongoing progress monitoring",
                "Optimized treatment frequency",
              ],
            },
            {
              icon: "✨",
              title: "Natural-Looking Results",
              desc: "Achieve visible, natural skin improvement with our gentle, effective treatments.",
              features: [
                "Subtle enhancements",
                "Long-lasting benefits",
                "Effortless aesthetics",
              ],
            },
            {
              icon: "🛡️",
              title: "Safety First",
              desc: "We maintain the highest standards of safety and hygiene in our treatment facilities.",
              features: [
                "Medical-grade environment",
                "Strict protocols",
                "Patient-centric care",
              ],
            },
            {
              icon: "💯",
              title: "Proven Success",
              desc: "Join thousands of happy clients who have transformed their skin with our solutions.",
              features: [
                "Over 5000 satisfied clients",
                "Remarkable clinical outcomes",
                "Consistently high success rates",
              ],
            },
          ].map((benefit, index) => (
            <div className="ads-benefit-card" key={index}>
              <div className="ads-benefit-icon">{benefit.icon}</div>
              <div className="ads-benefit-content">
                <h3>{benefit.title}</h3>
                <p>{benefit.desc}</p>
                <ul className="ads-feature-list">
                  {benefit.features.map((feature, idx) => (
                    <li key={idx}>{feature}</li>
                  ))}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="ads-process-section" id="process">
        <div className="ads-process-header">
          <span className="ads-process-tag">Our Process</span>
          <h2>Your Journey to Clear, Flawless Skin</h2>
          <p className="ads-process-subtitle">
            Follow our comprehensive 4-step approach for safe and effective
            mole and birth mark removal.
          </p>
        </div>
        <div className="ads-process-timeline">
          {[
            {
              step: "01",
              title: "In-Depth Consultation",
              desc: "Kick off your journey with a thorough consultation to assess your moles/birth marks and skin needs.",
              details: [
                "Detailed skin examination",
                "Dermatoscopic evaluation",
                "Customized treatment roadmap",
                "Expectation setting",
              ],
              icon: "🔍",
            },
            {
              step: "02",
              title: "Tailored Treatment Planning",
              desc: "Our specialists design a personalized mole and birth mark removal plan just for you.",
              details: [
                "Individualized procedure selection",
                "Session scheduling",
                "Pre-procedure instructions",
              ],
              icon: "📋",
            },
            {
              step: "03",
              title: "Expert Removal Session",
              desc: "Experience our precise techniques for targeted and effective mole or birth mark removal.",
              details: [
                "Sterile preparation",
                "Precise application of chosen method",
                "Comfort-focused procedure",
                "Minimal scarring techniques",
              ],
              icon: "💉",
            },
            {
              step: "04",
              title: "Comprehensive Aftercare",
              desc: "Benefit from our dedicated follow-up care ensuring your skin heals optimally and remains clear.",
              details: [
                "Routine progress reviews",
                "Adaptive healing adjustments",
                "Scar management plans",
                "Long-term support",
              ],
              icon: "📈",
            },
          ].map((process, index) => (
            <div className="ads-process-step" key={index}>
              <div className="ads-step-container">
                <div className="ads-step-number-container">
                  <div className="ads-step-number">{process.step}</div>
                  <div className="ads-step-icon">{process.icon}</div>
                </div>
                <div className="ads-step-content">
                  <h3>{process.title}</h3>
                  <p className="ads-step-description">{process.desc}</p>
                  <ul className="ads-step-details">
                    {process.details.map((detail, idx) => (
                      <li key={idx}>{detail}</li>
                    ))}
                  </ul>
                </div>
              </div>
              {index < 3 && <div className="ads-connector-line"></div>}
            </div>
          ))}
        </div>
      </section>

      {/* Hidden SEO Content - Not visible to users but crawlable by search engines */}
      <div style={{ display: 'none' }}>
        <h2>Best Mole & Birth Mark Removal Treatment Services in Chennai Tamil Nadu and Bangalore Karnataka - H-Cura Locations</h2>
        
        <h3>Mole & Birth Mark Removal Treatment in Tambaram Chennai - Gandhi Road Location</h3>
        <p>
          Advanced mole and birth mark removal treatment services at our Tambaram clinic located at Gandhi Rd, opposite Valluvar Gurukulam, West Tambaram, Chennai, Tamil Nadu 600045. 
          Serving patients from Chromepet, Pallavaram, Perungalathur areas with Mole Removal Surgery, Laser Birth Mark Removal, Skin Tag Removal, Dermatoscopic Evaluation. 
          Specializing in Mole & Birth Mark Removal. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best mole removal treatment Tamil Nadu, birth mark removal specialist Chennai, dermatologist Tambaram, mole removal clinic Chromepet, birth mark treatment Pallavaram, skin tag removal Perungalathur.
        </p>
        
        <h3>Mole & Birth Mark Removal Clinic in Valasaravakkam Chennai - Krishnamachari Nagar</h3>
        <p>
          Professional mole and birth mark removal services at our Valasaravakkam branch located at 48, 1st Main Rd, Krishnamachari Nagar, Valasaravakkam, Chennai, Tamil Nadu 600116. 
          Serving Porur, Alwarthirunagar, Virugambakkam communities with Surgical Excision of Moles, Cryotherapy for Skin Lesions, Radiofrequency Mole Removal, Pigmented Birth Mark Treatment. 
          Specializing in Skin Lesion & Birth Mark Treatments. Phone: +91 88700 01377. Hours: Monday to Sunday: 10:00 AM - 8:00 PM.
          Mole removal treatment Valasaravakkam, birth mark clinic Porur, dermatologist Alwarthirunagar, mole removal specialist Virugambakkam, skin lesion removal Chennai Tamil Nadu.
        </p>
        
        <h3>Complete Mole & Birth Mark Removal Solutions in Gerugambakkam Chennai - Ramachandra Nagar</h3>
        <p>
          Comprehensive mole and birth mark removal treatment services at our Gerugambakkam clinic at Ground floor, 1668, sathyavanimuthu street, Ramachandra Nagar, keezh colony, Gerugambakkam, Chennai, Tamil Nadu 600128. 
          Providing services to Kundrathur, Mangadu, Poonamallee residents with Non-Surgical Mole Removal, Birth Mark Correction, Vascular Birth Mark Treatment, Skin Blemish Removal. 
          Offering Complete Skin Mark Solutions. Call: +91 88700 01377. Timing: Monday to Sunday: 10:00 AM - 8:00 PM.
          Mole removal treatment Gerugambakkam, birth mark clinic Kundrathur, dermatologist Mangadu, mole removal specialist Poonamallee, skin blemish removal Chennai Tamil Nadu.
        </p>

        <h3>Advanced Mole & Birth Mark Removal Treatment in Jayanagar Bangalore Karnataka</h3>
        <p>
          Premier mole and birth mark removal services at our Jayanagar Bangalore clinic located at Jayanagar, Bengaluru, Karnataka 560069. 
          Serving patients from Koramangala, BTM Layout, JP Nagar, Banashankari, Basavanagudi, Wilson Garden, Lalbagh areas with Advanced Mole Removal, Birth Mark Laser Treatment, Cosmetic Mole Removal, Skin Lesion Biopsy. 
          Specializing in Advanced Mole & Birth Mark Dermatology. Contact: +91 88700 01377. Open Monday to Sunday: 10:00 AM - 8:00 PM.
          Best mole removal treatment Bangalore, birth mark removal specialist Karnataka, dermatologist Jayanagar, mole removal clinic Koramangala, birth mark treatment BTM Layout, laser mole removal JP Nagar, 
          mole removal doctor Banashankari, skin lesion removal Basavanagudi, dermatology Wilson Garden, mole removal treatment Lalbagh, mole removal clinic Bangalore Karnataka, birth mark removal specialist Bengaluru.
        </p>

        <h3>Comprehensive Bangalore Karnataka Service Areas</h3>
        <p>
          H-Cura Multispeciality Clinic Bangalore provides mole and birth mark removal treatment services across Bangalore Karnataka including Jayanagar, Koramangala, BTM Layout, JP Nagar, 
          Banashankari, Basavanagudi, Wilson Garden, Lalbagh, Indiranagar, Whitefield, Electronic City, HSR Layout, Marathahalli, Bannerghatta Road, Hebbal, Yeshwantpur,
          Rajajinagar, Malleshwaram, Sadashivanagar, RT Nagar, Yelahanka, Kengeri, Vijayanagar, Nagarbhavi areas in Karnataka.
          Mole removal treatment Bangalore, birth mark removal Karnataka, dermatologist Bengaluru, mole removal clinic Bangalore, birth mark specialist Karnataka, laser mole removal Bangalore, 
          surgical mole removal Karnataka, cryotherapy skin lesions Bangalore, radiofrequency mole removal Karnataka, pigmented birth mark treatment Bangalore, vascular birth mark treatment Karnataka.
        </p>

        <h3>Chennai Tamil Nadu Service Areas Coverage</h3>
        <p>
          H-Cura Multispeciality Clinic Chennai provides mole and birth mark removal treatment services across Chennai Tamil Nadu including Tambaram East, Tambaram West, Chromepet, Pallavaram, 
          Perungalathur, Selaiyur, Chitlapakkam, Valasaravakkam, Porur, Alwarthirunagar, Virugambakkam, Ramapuram, Mugalivakkam, Gerugambakkam, Kundrathur, 
          Mangadu, Poonamallee, Nazarethpet, Thirumazhisai areas in Tamil Nadu.
          Mole removal treatment Chennai, birth mark removal Tamil Nadu, dermatologist Chennai, mole removal clinic Tamil Nadu, birth mark specialist Chennai, laser mole removal Tamil Nadu.
        </p>

        <h3>Advanced Mole & Birth Mark Removal Treatments Available Across Chennai Tamil Nadu and Bangalore Karnataka</h3>
        <p>
          Our Chennai Tamil Nadu and Bangalore Karnataka locations offer comprehensive mole and birth mark removal treatment including Mole Removal Surgery, Laser Birth Mark Removal, Skin Tag Removal, 
          Cryotherapy for Skin Lesions, Radiofrequency Mole Removal, Pigmented Birth Mark Treatment, Vascular Birth Mark Treatment, 
          Non-Surgical Mole Removal, and Cosmetic Mole Removal services.
          Best mole removal treatment Chennai Bangalore, birth mark removal specialist Tamil Nadu Karnataka, dermatologist Chennai Bangalore, mole removal clinic Tamil Nadu Karnataka.
        </p>

        <h3>Expert Mole & Birth Mark Removal Dermatology Team Chennai Tamil Nadu Bangalore Karnataka</h3>
        <p>
          Board-certified dermatologists and mole/birth mark removal specialists providing personalized treatment solutions across Tambaram Gandhi Road Chennai, 
          Valasaravakkam Krishnamachari Nagar Chennai, Gerugambakkam Ramachandra Nagar Chennai, and Jayanagar Bangalore locations in Tamil Nadu and Karnataka.
          Mole removal specialist Chennai Bangalore, birth mark dermatologist Tamil Nadu Karnataka, mole removal doctor Chennai Bangalore, birth mark removal treatment expert Tamil Nadu Karnataka.
        </p>

        <h3>SEO Keywords for Google Ranking</h3>
        <p>
          mole removal near me, birth mark removal near me, dermatologist near me, mole removal clinic near me, laser birth mark removal near me, best mole removal treatment, 
          professional mole removal, birth mark doctor, skin lesion clinic, dermatology clinic, laser mole removal, surgical mole removal, cryotherapy skin lesions, radiofrequency mole removal, 
          pigmented birth mark treatment, vascular birth mark treatment, skin tag removal, non surgical mole removal, cosmetic mole removal, mole biopsy, skin mark correction, 
          skin blemish removal, early skin cancer detection, safe mole removal, effective birth mark treatment, minimal scarring, 
          cosmetic dermatology, medical skincare, skin health, mole removal consultation, skin analysis, mole prevention, dermatological treatment, 
          skin wellness, birth mark therapy, skin problem solutions, mole removal for aesthetics, birth mark reduction, 
          mole removal specialist doctor, professional skin mark care, advanced mole removal treatment, innovative birth mark solutions, skin transformation, 
          clear skin treatment, flawless skin therapy, skin renewal, mole management, birth mark management, 
          non-invasive mole removal treatment, safe birth mark removal treatment, effective mole removal care, proven birth mark solutions, personalized mole removal treatment, 
          customized birth mark therapy, expert mole removal care, quality dermatology services, trusted mole removal clinic, reliable birth mark treatment, 
          affordable mole removal care, convenient dermatology, accessible mole removal treatment, comprehensive mole removal solutions.
        </p>
      </div>

      {/* Modal for Image Viewing with Navigation */}
      {isModalOpen && (
        <div className="ads-modal-overlay" onClick={closeModal}>
          <div className="ads-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="ads-close-modal" onClick={closeModal}>
              &times;
            </button>
            <button 
              className="ads-modal-nav ads-modal-prev" 
              onClick={navigatePrevious}
            >
              &#10094;
            </button>
            <img
              src={modalImage.src}
              alt={modalImage.alt}
              className="ads-modal-image"
            />
            <button 
              className="ads-modal-nav ads-modal-next" 
              onClick={navigateNext}
            >
              &#10095;
            </button>
            <div className="ads-modal-counter">
              {currentImageIndex + 1} / {images.length}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default Molebirth;
